var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "#574476"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5013 24.9582H13.5013C8.9763 24.9582 7.04297 23.0248 7.04297 18.4998V13.4998C7.04297 8.97484 8.9763 7.0415 13.5013 7.0415H15.168C15.5096 7.0415 15.793 7.32484 15.793 7.6665C15.793 8.00817 15.5096 8.2915 15.168 8.2915H13.5013C9.65964 8.2915 8.29297 9.65817 8.29297 13.4998V18.4998C8.29297 22.3415 9.65964 23.7082 13.5013 23.7082H18.5013C22.343 23.7082 23.7096 22.3415 23.7096 18.4998V16.8332C23.7096 16.4915 23.993 16.2082 24.3346 16.2082C24.6763 16.2082 24.9596 16.4915 24.9596 16.8332V18.4998C24.9596 23.0248 23.0263 24.9582 18.5013 24.9582Z",
    fill: "#574476"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0821 20.7415C12.5738 20.7415 12.1071 20.5581 11.7655 20.2248C11.3571 19.8165 11.1821 19.2248 11.2738 18.5998L11.6321 16.0915C11.6988 15.6081 12.0155 14.9831 12.3571 14.6415L18.9238 8.0748C20.5821 6.41647 22.2655 6.41647 23.9238 8.0748C24.8321 8.98314 25.2405 9.90814 25.1571 10.8331C25.0821 11.5831 24.6821 12.3165 23.9238 13.0665L17.3571 19.6331C17.0155 19.9748 16.3905 20.2915 15.9071 20.3581L13.3988 20.7165C13.2905 20.7415 13.1821 20.7415 13.0821 20.7415ZM19.8071 8.95814L13.2405 15.5248C13.0821 15.6831 12.8988 16.0498 12.8655 16.2665L12.5071 18.7748C12.4738 19.0165 12.5238 19.2165 12.6488 19.3415C12.7738 19.4665 12.9738 19.5165 13.2155 19.4831L15.7238 19.1248C15.9405 19.0915 16.3155 18.9081 16.4655 18.7498L23.0321 12.1831C23.5738 11.6415 23.8571 11.1581 23.8988 10.7081C23.9488 10.1665 23.6655 9.59147 23.0321 8.9498C21.6988 7.61647 20.7821 7.99147 19.8071 8.95814Z",
    fill: "#574476"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5403 14.1917C22.482 14.1917 22.4237 14.1834 22.3737 14.1667C20.182 13.5501 18.4403 11.8084 17.8237 9.61673C17.732 9.2834 17.9237 8.94173 18.257 8.84173C18.5903 8.75006 18.932 8.94173 19.0237 9.27506C19.5237 11.0501 20.932 12.4584 22.707 12.9584C23.0403 13.0501 23.232 13.4001 23.1403 13.7334C23.0653 14.0167 22.8153 14.1917 22.5403 14.1917Z",
    fill: "#574476"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.79eb296415553471ff81d0f0e86b87e1.svg";
export { ForwardRef as ReactComponent };